import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectElements } from '../store/selectors';
import { BoxWithHandle } from './box-with-handle';

export const DraggableBoxes = () => {
  const elements = useSelector(selectElements);
  const [filterText, setFilterText] = useState('');

  const filteredElements = elements.filter(
    item =>
      item.id.toString().includes(filterText) ||
      item.name?.toLowerCase().includes(filterText.toLowerCase()),
  );

  return (
    <div className="row my-2">
      <div className="col-md-2">
        <div className="input-blocks draggable-input-box-filter">
          <input
            type="text"
            placeholder="Enter task name or ID"
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            className="form-control"
            style={{
              height: '52px',
            }}
          />
        </div>
      </div>
      <div className="col-md-10">
        <div
          style={{
            display: 'flex',
            overflowX: 'auto',
          }}
        >
          {filteredElements.map(item => (
            <BoxWithHandle key={item.id} data={item} />
          ))}
        </div>
      </div>
    </div>
  );
};
